<template>
  <div id="logo-loader" :class="[{ active: isActive }, position]">
    <div class="gradient">
      <div class="wrap">
        <div class="line1"></div>
        <div class="line2"></div>
        <div class="circle"></div>
        <div class="circle2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isActive', 'position'],
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/css/variables';

#logo-loader {
  opacity: 0;
  transition: all 1s ease;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  left: 0;
  top: 0;
  z-index: -100;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .gradient {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 450px;
    height: 450px;
    background: radial-gradient($pink 15%, transparent 40%);
    margin: 0 auto;
  }

  .wrap {
    width: 70px;
    height: 60px;
    font-size: 10px;
    position: relative;
    padding: 10px 28px 10px 20px;
    background: $pink;
    animation: fade 2.5s infinite linear;
    > {
      div {
        display: inline-block;
      }
      .circle,
      .circle2 {
        position: absolute;
        border: 8px solid #fff;
        border-top-color: transparent;
        border-radius: 50%;
        height: 40px;
        width: 40px;
        animation: rotate-1 2.5s infinite ease-in-out;
      }
      .circle2 {
        animation: rotate-2 2.5s infinite ease-in-out;
      }
      .line1,
      .line2 {
        border-bottom: 5px solid #fff;
        border-left: 5px solid $pink;
        position: absolute;
      }
      .line1 {
        top: 28px;
        width: 50px;
        left: 10px;
        -webkit-animation: logo-load1 2.5s infinite ease-in-out;
        animation: logo-load1 2.5s infinite ease-in-out;
      }
      .line2 {
        top: 38px;
        width: 20px;
        left: 10px;
        -webkit-animation: logo-load2 2.5s infinite ease-in-out;
        animation: logo-load2 2.5s infinite ease-in-out;
      }
    }
  }

  &.absolute {
    position: absolute;
  }

  &.active {
    opacity: 1;
    z-index: 10000;
  }

  @keyframes logo-load1 {
    0%,
    100% {
      width: 0;
    }

    40%,
    60% {
      width: 50px;
      border-color: $purple;
      border-left: 5px solid $pink;
    }
  }

  @keyframes logo-load2 {
    0%,
    100% {
      width: 0;
    }

    40%,
    60% {
      width: 20px;
      border-color: $purple;
      border-left: 5px solid $pink;
    }
  }

  @keyframes rotate-1 {
    0%,
    100% {
      transform: rotate(0deg);
    }
    40%,
    60% {
      transform: rotate(135deg);
      border-color: $purple;
      border-top-color: transparent;
    }
  }

  @keyframes rotate-2 {
    0%,
    100% {
      transform: rotate(-45deg);
    }
    40%,
    60% {
      transform: rotate(90deg);
      border-color: $purple;
      border-top-color: transparent;
    }
  }

  @keyframes fade {
    0%,
    15%,
    85%,
    100% {
      opacity: 0;
    }

    50% {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// LogoLoader.vue?a9f2762e